import { render, staticRenderFns } from "./savedAddressItem.vue?vue&type=template&id=35dd300f&scoped=true"
import script from "./savedAddressItem.vue?vue&type=script&lang=js"
export * from "./savedAddressItem.vue?vue&type=script&lang=js"
import style0 from "./savedAddressItem.vue?vue&type=style&index=0&id=35dd300f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd300f",
  null
  
)

export default component.exports